import { type ReactElement, type ReactNode } from "react"
import { ButtonSize, ButtonStyle } from "./themes"

export interface ButtonProps {
	type?: "submit" | "button" | "reset";
	buttonStyle: any;
	size: any;
	children?: ReactNode;
	disabled?: boolean;
	className: string;
	handleClick?: () => void;
}

export default function Button(props: ButtonProps): ReactElement {
	const classNames = ButtonStyle[props.buttonStyle as keyof typeof ButtonStyle] + " " + ButtonSize[props.size as keyof typeof ButtonSize] + " " + props.className;

	return <>
		<button className={classNames} type={props.type} disabled={props.disabled} onClick={props?.handleClick}>{props.children}</button>
	</>
}

